import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { formatDateDDMMYYYY } from './dateFormat';

function loadImage(src) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = src;
    });
}

function drawCompanyHeader(doc, pageWidth, pageTitle, subtitleLines = []) {
    doc.setLineWidth(0.5);
    doc.line(15, 42, pageWidth - 15, 42);

    doc.setFontSize(15);
    doc.text('Shivam Buildcare', 15, 50);

    doc.setFontSize(7);
    doc.text('B-531, Money Plant High Street, Opp BSNL Office,', 15, 55);
    doc.text('Godrej Garden City Jagatpur Road, Ahmedabad,', 15, 58);
    doc.text('Ahmedabad, Gujarat, 382470', 15, 61);
    doc.text('GST No - 24JSJPK5641B1ZT', 15, 67);
    doc.text('Pan No - JSJPK5641B', 15, 70);
    doc.text('Udyam No.GJ-01-0371564', 15, 73);

    doc.setFontSize(15);
    doc.text(pageTitle, pageWidth - 20, 50, { align: 'right' });

    doc.setFontSize(7);
    subtitleLines.forEach((line, index) => {
        doc.text(line, pageWidth - 20, 55 + (index * 3), { align: 'right' });
    });

    doc.line(15, 78, pageWidth - 15, 78);
}

export async function exportFinancialsListPdf({
    pageTitle,
    fileName,
    fromDate,
    toDate,
    searchTerm = '',
    head,
    body,
    totalAmount,
    columnStyles = {}
}) {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    doc.setLineWidth(0.5);
    doc.rect(5, 5, pageWidth - 10, pageHeight - 10);

    try {
        const img = await loadImage(`${process.env.PUBLIC_URL}/assets/companyLogo.png`);
        const logoWidth = 80;
        const logoHeight = 35;
        doc.addImage(img, 'PNG', (pageWidth - logoWidth) / 2, 7, logoWidth, logoHeight);
    } catch (error) {
        console.error('Could not load company logo for PDF:', error);
    }

    const subtitleLines = [
        `Period: ${formatDateDDMMYYYY(fromDate)} to ${formatDateDDMMYYYY(toDate)}`
    ];
    if (searchTerm.trim()) {
        subtitleLines.push(`Search: ${searchTerm.trim()}`);
    }

    drawCompanyHeader(doc, pageWidth, pageTitle, subtitleLines);

    autoTable(doc, {
        startY: 85,
        head,
        body,
        theme: 'grid',
        headStyles: {
            fillColor: [34, 34, 34],
            textColor: 255,
            fontStyle: 'bold'
        },
        styles: {
            fontSize: 8,
            cellPadding: 2.5
        },
        columnStyles,
        margin: { left: 15, right: 15 }
    });

    const tableEndY = doc.lastAutoTable.finalY + 8;
    doc.setFontSize(10);
    doc.setFont(undefined, 'bold');
    doc.text(`Total: ${totalAmount}`, pageWidth - 15, tableEndY, { align: 'right' });

    doc.save(fileName);
}
